import styled from '@emotion/styled';
import UserAvatar from '@/components/UserAvatar';
import mediaQuery from '@/lib/styling/mediaQuery';

const CommentUserAvatar = styled(UserAvatar)({
  '&&&': {
    marginRight: 12,
    width: 30,
    height: 30,
    fontSize: 16,
    [mediaQuery(1024)]: {
      width: 36,
      height: 36,
      fontSize: 19,
    },
  },
});

export default CommentUserAvatar;
